export default function BurderMenu() {
  return (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="1" fill="#333333" />
      <rect y="6" width="16" height="1" fill="#333333" />
      <rect y="12" width="16" height="1" fill="#333333" />
    </svg>
  );
}
